const DOMPurifyConfiguration = {
    ALLOWED_TAGS: ['p', 'br', 'b', '#text'], // only <P>, <br>, <b> and text nodes
}


module.exports = {
    DOMPurifyConfiguration
}